<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'">
          <label class="d-flex align-items-center mb-0">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div [ngClass.xl]="'float-left ml-2'" [ngClass.sm]="'mt-1'" [ngClass.md]="'float-left ml-2'">
          <select [(ngModel)]="searchStatus" class="form-control">
            <option value="10" selected>{{ "ALL_FEMALE_PLURAL" | translate }}</option>
            <option value="0">{{ "PENDING" | translate }}</option>
            <option value="1">{{ "APPROVED_FEMALE_PLURAL" | translate }}</option>
            <option value="2">{{ "NOT_APPROVED_PLURAL" | translate }}</option>
          </select>
        </div>
        <div class="float-right" [ngClass.sm]="'d-none'">
          <div class="d-inline-block">
            <label class="d-flex align-items-center mb-0"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <!-- desktop-->
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 170"
          [limit]="tableLimit"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [footerHeight]="50"
          [rows]="absenceList()"
        >
          <ngx-datatable-column name="{{ 'TYPE_ABSENCE' | translate }}" prop="type.name" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.type.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'FROM' | translate }}" prop="from" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ getFormat(row.from, row) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'TO' | translate }}" prop="to" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ getFormat(row.to, row) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="status" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-success" *ngIf="row.status === 1">{{ row.enabled_label }}</span>
              <span class="badge badge-warning" *ngIf="row.status === 0">{{ row.enabled_label }}</span>
              <span class="badge badge-danger" *ngIf="row.status === 2">{{ row.enabled_label }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="btn btn-outline-secondary btn-sm" (click)="openModal(viewAbsence, row)">{{ "VIEW" | translate }}</button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'TYPE_ABSENCE' | translate }}" prop="from" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12" [ngClass.md]="'pl-0'">
                  <span>{{ row.type.name }}</span>
                </div>
                <div class="col-12 my-075" [ngClass.md]="'pl-0'">
                  <span class="mr-05">{{ "FROM_PERSON" | translate }}: {{ getFormat(row.from, row) }}</span>
                  <span>{{ "TO" | translate }}: {{ getFormat(row.to, row) }}</span>
                </div>
                <div class="col-6" [ngClass.md]="'pl-0'">
                  <span class="badge badge-success" *ngIf="row.status === 1">{{ row.enabled_label }}</span>
                  <span class="badge badge-warning" *ngIf="row.status === 0">{{ row.enabled_label }}</span>
                  <span class="badge badge-danger" *ngIf="row.status === 2">{{ row.enabled_label }}</span>
                </div>
                <div class="col-6 text-right" [ngClass.md]="'pr-2'">
                  <button class="btn btn-outline-secondary btn-sm" (click)="openModal(viewAbsence, row)">{{ "VIEW" | translate }}</button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal -->
<ng-template #viewAbsence let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ currentAbsence.type.category | titlecase }}</h3>
      <div class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FIRSTNAME" | translate }}:</small>
          <p>{{ currentAbsence.employee.complete_name }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "TYPE_ABSENCE" | translate }}:</small>
          <p>{{ currentAbsence.type.name }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <small *ngIf="currentAbsence.type.category === 'permesso'" class="text-muted mb-0 pb-0">{{ "HOUR_FROM" | translate }}:</small>
          <small *ngIf="currentAbsence.type.category !== 'permesso'" class="text-muted mb-0 pb-0">{{ "FROM" | translate }}:</small>

          <p>{{ getFormat(currentAbsence.from, currentAbsence) }}</p>
        </div>
        <div class="col-6">
          <small *ngIf="currentAbsence.type.category === 'permesso'" class="text-muted mb-0 pb-0">{{ "HOUR_TO" | translate }}:</small>
          <small *ngIf="currentAbsence.type.category !== 'permesso'" class="text-muted mb-0 pb-0">{{ "TO" | translate }}:</small>
          <p>{{ getFormat(currentAbsence.to, currentAbsence) }}</p>
        </div>
      </div>
      <div *ngIf="currentAbsence.note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "NOTE" | translate }}:</small>
          <p>{{ currentAbsence.note }}</p>
        </div>
      </div>
      <div *ngIf="currentAbsence.file" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "FILE" | translate }}:</small>
          <a class="d-block text-primary" (click)="loadAttachment(currentAbsence.file)">{{ "VIEW" | translate }} {{ "FILE" | translate }}</a>
        </div>
      </div>
      <div *ngIf="currentAbsence.status_note" class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "MOTIVATION" | translate }}:</small>
          <p>{{ currentAbsence.status_note }}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button (click)="modal.close()" type="button" class="btn btn-primary">{{ "ALERT.BTN_CLOSE" | translate }}</button>
    </div>
  </form>
</ng-template>
<!-- / Modal -->
